import FeatureCardUtils from 'javascripts/feature_card_utils';
import $ from 'jquery';

const FeatureCardRepositioner = {
  moveToTop(newReleaseId, featureIds) {
    return reposition(newReleaseId, featureIds, 0);
  },

  moveToBottom(newReleaseId, featureIds) {
    const lastPosition = findReleaseElement(newReleaseId)
      .find('.card:not(.card--placeholder)')
      .last()
      .attr('data-feature-position');

    return reposition(newReleaseId, featureIds, +lastPosition);
  },
};

export default FeatureCardRepositioner;

function findReleaseElement(releaseId) {
  return $(`.release-feature-list[data-release-id='${releaseId}']`);
}

function reposition(newReleaseId, featureIds, position) {
  const data = {
    reactive_client_id: window.reactiveClientId(),
    release_id: newReleaseId,
    position,
  };

  const positionList = (featureIds || []).map((featureId, index) => ({
    id: featureId,
    release_id: newReleaseId,
  }));

  if (featureIds[0].includes('-E-')) {
    data.epics = positionList;
  } else {
    data.features = positionList;
  }

  return $.ajax({
    type: 'PUT',
    url: '/features/reposition',
    data,
    dataType: 'json',
    statusCode: {
      206: script => eval(script.responseText), // eslint-disable-line no-eval
      200: response => FeatureCardUtils.handle_reposition_callback(response),
    },
  });
}
